import {css} from '@emotion/react'
import styled from '@emotion/styled'

import mirror from '@vio/atlas/src/utils/mirror'
import {cssTheme} from '@vio/atlas/themes'

import {BaseDatePicker, DAY_SIZE} from '../styles'

const layoutStyles = css`
  &:not(.--is-vertical) {
    width: 100%;
  }
  &.--is-vertical {
    padding-left: 0;
    padding-right: 0;

    .calendar-week-days-wrapper {
      width: 100%;
      display: table-row;
    }
  }
`

const mobileNavStyles = css`
  &.--is-vertical {
    .months-wrapper {
      position: relative;
    }

    .nav-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: ${cssTheme.layout.spacing.s500} 0;
    }

    .nav-button {
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 0 ${cssTheme.layout.spacing.s500};

      &[aria-disabled='true'] {
        cursor: default;
      }
      ${mirror()}
    }
  }
`
const dayInnerStyles = css`
  .day-inner.neutral[data-id='DayWithPrice'] {
    background-color: ${cssTheme.colors.background.neutral.secondary};
    border-radius: ${cssTheme.layout.radius.lg};
  }

  .day-inner.high[data-id='DayWithPrice'] {
    color: ${cssTheme.colors.content.warning.secondary};
    background-color: ${cssTheme.colors.background.warning.secondary};

    .price {
      color: ${cssTheme.colors.content.warning.primary};
    }
  }

  .day-inner.low[data-id='DayWithPrice'] {
    background-color: ${cssTheme.colors.background.success.secondary};
    .price {
      color: ${cssTheme.colors.content.success.primary};
    }
  }

  .day-inner .label {
    ${cssTheme.typography.bodyS};
    color: ${cssTheme.colors.content.neutral.secondary};
  }

  .day-inner[data-id='DayWithPrice'] .price {
    ${cssTheme.typography.titleXS};
    color: ${cssTheme.colors.content.neutral.primary};
  }

  .today .day-inner .label {
    ${cssTheme.typography.titleS};
    color: ${cssTheme.colors.datePicker.today.content};
  }
`

const monthGridStyles = css`
  &:not(.--is-vertical):not(.--is-single-month) .calendar-wrapper {
    padding: ${cssTheme.layout.spacing.s600};
  }
`

const weekDayWrapperStyles = css`
  .week-day-wrapper {
    min-width: ${DAY_SIZE}px;
    width: 100%;

    .week-day-inner {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      ${cssTheme.typography.bodyS};
      color: ${cssTheme.colors.content.neutral.secondary};
      min-width: ${DAY_SIZE}px;
      margin: 0;
      margin-bottom: ${cssTheme.layout.spacing.s400};
    }
  }
`

const dayCellStyles = css`
  &:not(.--is-vertical):not(.--is-single-month) .day-cell {
    min-width: ${DAY_SIZE}px;
    width: 100%;
  }

  .day-cell .--should-show-price {
    padding: ${cssTheme.layout.spacing.s200} 0;
  }
`

export const PricePredictionContainer = styled(BaseDatePicker)`
  ${layoutStyles}
  ${mobileNavStyles}
  ${monthGridStyles}
  ${weekDayWrapperStyles}
  ${dayInnerStyles}
  ${dayCellStyles}
`
